import {Topic} from '@shared/models/topic.model';
import {SchoolingParticipant} from '@shared/models/schooling-participant.model';

export class SchoolingTuition {
  id: number = null;
  topicId: number = 0;
  bookletId: number = null;
  status: number = 0;
  tuitionDate: string = '';
  createDate: string = '';
  tuitionTime: string = '';
  validUntilDate: string = '';
  maxParticipants: number;
  acceptsParticipants: boolean = true;
  roomId: number = null;
  locationId: number = null;
  description: string = '';
  lecturerEmployeeId: number = null;
  externalLecturerId: number = null;
  assigneeEmployeeId: number = null;
  organiserCompanyId: number = null;
  organiserExternalCompanyId: number = null;
  requiredField: boolean;
}

export class SchoolingTuitionDetails {
  tuition: SchoolingTuition = new SchoolingTuition();
  topic: Topic = new Topic();
  participants: SchoolingParticipant[] = [];
}
